import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import { useField, useFormikContext } from "formik";
import imageCompression from "browser-image-compression";
import { getBase64 } from "../../constants/imagePicker.helper";
import { useStore } from "../../contexts/store-provider";

interface IProps {
    children: React.ReactNode;
    className: string;
    name: string;
    "data-testid"?: string;
    intl: any;
    onChange: () => void;
    value: any;
    disabled: boolean;
    readOnly: boolean;
    label?: string;
}

const FormikFormImagePicker = (props: IProps) => {
    const [field, meta, helpers] = useField(props);
    const [focus, setFocus] = useState(false);
    const { setFieldValue, setFieldError } = useFormikContext<any>();
    const [calendarIsOpen, setCalendarIsOpen] = useState(false);

    const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 200,
        useWebWorker: true,
    }
    
    const optionsThumbnail = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 30,
        useWebWorker: true,
    }

    const handleCalendarClose = () => {
        if (calendarIsOpen) setCalendarIsOpen(false);
    };

    const onClickCalendarIcon = () => {
        setCalendarIsOpen(!calendarIsOpen);
    };

    const blurHandler = () => {
        if (!props.value)
            setFocus(false)
    }

    useEffect(() => {
        if (props.value)
            setFocus(true)
    }, [props.value]);

    return (
        <>
            <input id="imgupload" name="file" type="file" accept="image/*" disabled={props.disabled} 
            onChange={props.disabled ? () =>{} :
                async (event) => {
                try {
                    const compressedFile = await imageCompression(event.currentTarget.files![0], options);
                    getBase64(compressedFile)
                        .then(result => {
                            helpers.setValue(result);
                        })
                        .catch(err => {
                            helpers.setError("error_upload_image");
                        });
                    const compressedThumbnailFile = await imageCompression(event.currentTarget.files![0], optionsThumbnail);
                    getBase64(compressedThumbnailFile)
                        .then(result => {
                            setFieldValue("ThumbnailImage", result);
                        })
                        .catch(err => {
                            helpers.setError("error_upload_image");
                        });
                }
                catch (error) {
                    helpers.setError("error_upload_image");
                }
            }} 
            style={{ display: "none" }} />
            
            
                {(!field.value || field.value === "") && 
                <label htmlFor='imgupload'>
                    <div className="position-relative upload-size-image">
                        {/* <div className="upload-icon-image">
                            <span className="material-symbols-outlined">
                                publish
                            </span>
                        </div> */}
                        <div className="user-profile-box">
                            <div className="upload-profile align-middle">
                                <i className="bi bi-plus-lg"></i>
                                <p className="text-center">
                                    <FormattedMessage id="upload_image" />
                                </p>
                            </div>
                        </div>
                    </div>
                </label>
                }
                
                {(field.value && field.value !== "") && 
                <>
                <div className="position-relative upload-size-image uploaded-image">
                    <label htmlFor='imgupload'></label>
                    <img
                        {...field} {...props}
                        className={"user-profile-box glow-on-hover"}
                        src={field.value}
                    // alt={"gym"}

                    />
                    <button className="remove-img" type="button" onClick={props.disabled ? ()=>{} : ()=>{helpers.setValue("")}}>
                    <svg id="fi_9759080" enableBackground="new 0 0 32 32" height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m16 2c-18.5.6-18.5 27.4 0 28 18.5-.6 18.5-27.4 0-28z" fill="#f44336"></path><path d="m17.4 16 4.2-4.2c.9-.9-.5-2.3-1.4-1.4l-4.2 4.2-4.2-4.2c-.9-.9-2.3.5-1.4 1.4l4.2 4.2-4.2 4.2c-.9.9.5 2.3 1.4 1.4l4.2-4.2 4.2 4.2c.9.9 2.3-.5 1.4-1.4z" fill="#eee"></path></g></svg>
                    </button>
                </div>
                </>
                }
            <FormikFormErrorHandler intl={props.intl} meta={meta} />
        </>
    );
};

export default injectIntl(FormikFormImagePicker);
